module.exports = __webpack_public_path__ + "assets/img/625A0487.57f74d76.jpg";